import { NavigationMenuExample } from '@/components/examples/navigation-menu-example';

/**
 * Demo page for the Navigation Menu component
 * Route: /examples/navigation-menu
 */
export function NavigationMenuDemoPage() {
  return <NavigationMenuExample />;
}
